const RankTypes = {
    FETCH_START:    '[MANAGERS][RANK] FETCH START',
    FETCH_SUCCESS:  '[MANAGERS][RANK] FETCH SUCCESS',
    FETCH_FAILURE:  '[MANAGERS][RANK] FETCH FAILURE'
};

export default RankTypes;